export default "/images/microsoft_azure_service__upper.png";